// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
export const environment = {
  name: 'Flyplus',
  theme: 'flyplus',
  production: true,
  environmentName: 'development',
  // No fixed service timezone: service slots use the backend-provided offset.
  serviceTimeZoneOffset: undefined as string | undefined,
  hmr: false,
  enableApplePay: true,
  enableCustomerAnalytics: true,
  enableGoogleAnalytics: false,
  enableChatbot: true,
  authType: 'local',
  version: require('../../package.json').version + '-development',
  appVersion: require('../../package.json').version + '-development',
  serverUrl: 'https://bountyportalbackendhelper.azurewebsites.net',

  skuUrl: 'https://ahoyskus.azurewebsites.net',
  vsUrl: 'https://ahoyvirtualstoremerchant.azurewebsites.net',

  hadirUrl: 'https://hadiradminportalapi.azurewebsites.net/',
  hadirSmsUrl:
    'https://flyplus-backend-service-integ.azurewebsites.net/customer',

  deliveryUrl: 'https://ahoydelivery.azurewebsites.net',
  merchantUrl: 'https://ahoydeliverymerchant.azurewebsites.net',
  transactionsUrl: 'https://ahoytransaction.azurewebsites.net',
  profileUrl: 'https://ahoyprofile.azurewebsites.net',

  ahoyAuthUrl:
    'https://flyplus-backend-service-integ.azurewebsites.net/customer',
  sgsCustomerUrl:
    'https://flyplus-backend-service-integ.azurewebsites.net/customer',
  signalRUrl: 'https://flyplus-backend-service-integ.azurewebsites.net',

  authAuthApi: 'https://ahoyauthapi.azurewebsites.net',
  googlePlacesUrl: 'https://maps.googleapis.com',

  activeDirectoryUrl: 'auth/token',
  refreshTokenUrl: 'auth/refresh-token',
  activeDirectoryClientId: 'e748d749-04bb-488a-b90b-517a417adc0e',
  activeDirectoryScope: '',

  defaultLanguage: 'en-US',
  supportedLanguages: ['en-US', 'ar'],
  google_api_key: 'AIzaSyAAVVmfkjLNhBMOkkTgDbuuRw5gJbPc6rI',
  here_maps_key: 'aKG-y3wtAihnFdYB9jHZ34satHq9RjtSADRw7eox6Lc',

  firebase: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },

  airlineCode: 'SVA',
  countrySettings: {
    country: 'UAE',
    countryNameCode: 'AE',
    countryCode: '971',
    currency: 'SAR',
    minAgeForAccountOpening: 18, // Ensure this key is present for age validation
    nationalAddress: true,
    cities: [
      {
        id: 1,
        name: 'Fujairah',
      },
      {
        id: 2,
        name: 'Ras Al Khaimah',
      },
      {
        id: 3,
        name: 'Sharjah',
      },
      {
        id: 4,
        name: 'Ajman',
      },
      {
        id: 5,
        name: 'Umm Al Quwain',
      },
      {
        id: 6,
        name: 'Dubai',
      },
      {
        id: 7,
        name: 'Al Ain',
      },
      {
        id: 8,
        name: 'Abu Dhabi',
      },
    ],
    availableTemperatures: [12, 21],
    cashAvailable: true,
    cardAvailable: true,
  },
};
